var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeThnku(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12231 10.1129L5.83076 11.4355C6.0512 11.656 6.5472 11.7662 6.87787 11.7662H8.97209C9.63343 11.7662 10.3499 11.2702 10.5152 10.6089L11.8379 6.58577C12.1134 5.81421 11.6174 5.15288 10.7908 5.15288H8.58631C8.25565 5.15288 7.98009 4.87732 8.0352 4.49154L8.31076 2.72799C8.42098 2.23199 8.09031 1.68088 7.59431 1.51554C7.15343 1.35021 6.60231 1.57065 6.38187 1.90132L4.12231 5.2631",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12231 10.1129L5.83076 11.4355C6.0512 11.656 6.5472 11.7662 6.87787 11.7662H8.97209C9.63343 11.7662 10.3499 11.2702 10.5152 10.6089L11.8379 6.58577C12.1134 5.81421 11.6174 5.15288 10.7908 5.15288H8.58631C8.25565 5.15288 7.98009 4.87732 8.0352 4.49154L8.31076 2.72799C8.42098 2.23199 8.09031 1.68088 7.59431 1.51554C7.15343 1.35021 6.60231 1.57065 6.38187 1.90132L4.12231 5.2631",
    stroke: "#21A7DF",
    strokeWidth: 0.826667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31165 10.1129V4.712C1.31165 3.94044 1.64231 3.66489 2.41387 3.66489H2.96498C3.73653 3.66489 4.0672 3.94044 4.0672 4.712V10.1129C4.0672 10.8844 3.73653 11.16 2.96498 11.16H2.41387C1.64231 11.16 1.31165 10.8844 1.31165 10.1129Z",
    fill: "white",
    stroke: "#21A7DF",
    strokeWidth: 0.826667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeThnku);
export default __webpack_public_path__ + "static/media/like-thnku.a6078136e67dbbf8b7ce071522a4567e.svg";
export { ForwardRef as ReactComponent };